module.exports = __webpack_public_path__ + "static/media/docker-logo.089298c5.png";